var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundPluses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 1024,
    viewBox: "0 0 480 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.99 42V64.6306",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.979 53.3151H255",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4464 235V257.631",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4363 246.316H61.4569",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.99 793V815.631",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.979 804.315H370",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9895 719V741.631",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9794 730.316H76",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9896 941V963.631",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.98 952.315H85.0001",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.99 258V280.631",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.979 269.316H382",
    stroke: "#1A2126",
    strokeWidth: 1.2627,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPluses);
export default __webpack_public_path__ + "static/media/background-pluses.f66a45510406812e82173e0b926c5d73.svg";
export { ForwardRef as ReactComponent };